export default __webpack_public_path__ + "static/media/Sicilian-Cannoli.adfbe26a.jpg";